import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAndroidstudio,
  SiPostman,
  SiMacos,
  SiXcode
} from "react-icons/si";
import { VscVscode } from "react-icons/vsc";

function TechIcon({ icon: Icon, name }) {
  return (
    <Col xs={4} md={2} className="tech-icons">
      <div className="tech-icon-wrap" data-name={name}>
        <Icon />
      </div>
    </Col>
  );
}

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <TechIcon icon={VscVscode}        name="VS Code" />
      <TechIcon icon={SiPostman}        name="Postman" />
      <TechIcon icon={SiAndroidstudio}  name="Android Studio" />
      <TechIcon icon={SiMacos}          name="macOS" />
      <TechIcon icon={SiXcode}          name="Xcode" />
    </Row>
  );
}

export default Toolstack;
